
import HeFeiIndex from '@/views/study/HeFei/index'

export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'HeFei/index',
      name: 'HeFeiIndex',
      component: HeFeiIndex
    }

  ]
}
